import type { SortState } from '@/hooks/useSort';

interface Props {
  label:       string;
  sortKey:     string;
  sort:        SortState;
  onSort:      (key: string) => void;
  className?:  string;
}

export default function SortableTh({ label, sortKey, sort, onSort, className = '' }: Props) {
  const active = sort.key === sortKey;
  const arrow  = !active ? '↕' : sort.dir === 'asc' ? '↑' : '↓';

  return (
    <th
      className={`px-4 py-3 cursor-pointer select-none whitespace-nowrap ${className}`}
      onClick={() => onSort(sortKey)}
    >
      <span className="flex items-center gap-1">
        {label}
        <span className={`text-[10px] ${active ? 'text-gold' : 'text-blue-400 opacity-60'}`}>
          {arrow}
        </span>
      </span>
    </th>
  );
}
